import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import palletApi, { PalletData } from '../apis/pallet.api'
import { TransferData } from '../apis/transfer.api'
import { CaseData } from '../apis/inventoryCase.api'
import { MetadataData } from '../apis/metadata.api'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import ContentAside from '../components/ContentAside'
import InventoryTable from '../partials/InventoryTable'
import InventoryCasesTable from '../partials/InventoryCasesTable'
import InventoryLocationMap from '../partials/InventoryLocationMap'
import InventoryMetadataTable from '../partials/InventoryMetadataTable'

interface InventoryRouteState {
  id: number
}

interface InventoryProps
  extends RouteComponentProps<any, any, InventoryRouteState> {}

interface InventoryState {
  pallet: PalletData | null
  transfers: TransferData[]
  cases: CaseData[]
  metadatas: MetadataData[]
}

class Inventory extends Component<InventoryProps, InventoryState> {
  constructor (props: InventoryProps) {
    super(props)
    this.state = {
      pallet: null,
      transfers: [],
      cases: [],
      metadatas: []
    }
  }

  get id () {
    return this.props.location.state.id
  }

  readPallet () {
    palletApi.read(this.id, pallet => {
      if (!pallet) return
      this.setState({ pallet })
    })
  }

  listTransfers () {
    palletApi.listTransfers(this.id, transfers => {
      if (!transfers) return
      this.setState({ transfers })
    })
  }

  listCases () {
    palletApi.listCases(this.id, cases => {
      if (!cases) return
      this.setState({ cases })
    })
  }

  listMetadatas () {
    palletApi.listMetadatas(this.id, metadatas => {
      if (!metadatas) return
      this.setState({ metadatas })
    })
  }

  componentDidMount () {
    this.readPallet()
    this.listTransfers()
    this.listCases()
    this.listMetadatas()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="half">
          <InventoryTable pallet={this.state.pallet} />
        </ContentMain>
        <ContentAside layout="half">
          <div className="flex flex-col gap-5">
            <InventoryLocationMap transfers={this.state.transfers} />
            <InventoryCasesTable cases={this.state.cases} />
            <InventoryMetadataTable metadatas={this.state.metadatas} />
          </div>
        </ContentAside>
      </ContentLayout>
    )
  }
}

export default withRouter(Inventory)
